"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPortal = ModalPortal;

var _dom = require("@slyk/dom");

var _reactDom = require("react-dom");

var _styledTools = require("styled-tools");

var _bodyScroll = _interopRequireDefault(require("./body-scroll"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "modal-portal__Wrapper",
  componentId: "sc-rm34rj-0"
})(["transition:visibility ", ";visibility:", ";"], (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isVisible', 'visible', 'hidden'));
/**
 * Create react portal.
 */


function createReactPortal(children, elementId) {
  if (!(0, _dom.canUseDOM)()) {
    return null;
  }

  var domElement = document.getElementById(elementId);

  if (!domElement) {
    return null;
  }

  return /*#__PURE__*/(0, _reactDom.createPortal)(children, domElement);
}
/**
 * Export `ModalPortal` component.
 */


function ModalPortal(props) {
  var children = props.children,
      isOpen = props.isOpen;
  var handleGhostClick = (0, _react.useCallback)(function (event) {
    if (event) {
      event.stopPropagation();
    }
  }, []);
  return createReactPortal( /*#__PURE__*/_react["default"].createElement(Wrapper, {
    isVisible: isOpen,
    onClick: handleGhostClick
  }, /*#__PURE__*/_react["default"].createElement(_bodyScroll["default"], {
    enabled: !isOpen
  }, children)), 'modal-root');
}